import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "../../../atom/Dropdown/Dropdown";

import CalendarColorBadge from "../../../atom/Calendar/CalendarColorBadge";
import clsx from "clsx";
import { CheckIcon } from "../../../../icons";
import { UserCalendarType } from "../../../../types/userCalendars/type";
import { useMemo, useState } from "react";
import Tooltip from "../../../atom/Tooltip";

interface CalendarDropdownProps {
  calendarDropdownRef: React.RefObject<HTMLDivElement>;
  selectedValue: string;
  calendarList: UserCalendarType[];
  onSelect: (value: string) => void;
}

const CalendarDropdown = ({
  calendarDropdownRef,
  selectedValue,
  calendarList,
  onSelect,
}: CalendarDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedCalendar = useMemo(() => {
    return calendarList.find((calendar) => calendar.id.toString() === selectedValue);
  }, [calendarList, selectedValue]);

  const handleEscapeKeyDown = (e: KeyboardEvent) => {
    // esc 눌렀을 때 전파 막기(해당 dropdown만 닫히도록)
    e.stopPropagation();
  };

  const handleDropdownItemKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      // enter 눌렀을 때 상위 모달 닫히지 않도록 막기
      e.stopPropagation();
    }
  };

  if (!calendarList.length || !selectedCalendar) return null;

  return (
    // NOTE modal={false}으로 상위 모달 닫히지 않도록 설정(taskDetail은 이중 모달이기 때문에 필요)
    <DropdownMenu
      modal={false}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Tooltip
        content="Calendar"
        isShow={isOpen ? false : undefined}
      >
        <DropdownMenuTrigger asChild>
          <button className="cursor-pointer rounded-[5px] p-1 hover:bg-w-8-hover data-[state=open]:bg-w-8-hover">
            <CalendarColorBadge color={selectedCalendar.backgroundColor} />
          </button>
        </DropdownMenuTrigger>
      </Tooltip>

      <DropdownMenuContent
        ref={calendarDropdownRef}
        width="200px"
        sideOffset={5}
        align={"end"}
        side={"bottom"}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
        onEscapeKeyDown={handleEscapeKeyDown}
      >
        <DropdownMenuRadioGroup
          value={selectedValue}
          onValueChange={onSelect}
        >
          {calendarList.map((calendar) => (
            <DropdownMenuRadioItem
              key={calendar.id}
              value={calendar.id.toString()}
              className={clsx(
                "flex h-8 cursor-pointer select-none items-center gap-[6px] px-2 text-[12px] leading-[1] outline-none data-[highlighted]:bg-w-8-hover",
                selectedValue === calendar.id.toString()
                  ? "text-moba data-[highlighted]:text-moba"
                  : "text-80 hover:text-white data-[highlighted]:text-white"
              )}
              onKeyDown={handleDropdownItemKeyDown}
            >
              <CalendarColorBadge color={calendar.backgroundColor} />
              <div className={clsx("flex-grow overflow-hidden text-ellipsis whitespace-nowrap")}>
                {calendar.name}
              </div>
              {selectedValue === calendar.id.toString() && (
                <CheckIcon
                  color={"var(--moba)"}
                  className="text-[14px]"
                />
              )}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CalendarDropdown;
